export const css = {
    root: '_17TyVDLM',
    close: '_1_efhPNG',
    indicator: '_3N_tc3mV',
    tabButtons: '_28DM9AbR',
    tabButton: '_3bC7MWLV',
    disabledTabButton: '_3yEJXlmV',
    activeTabButton: '_4SIfwRNI',
    closeable: '_1BkP9THj',
    tab: '_2wnSY6iz',
    alignLeft: '_2o38Irbb',
    alignRight: '_1E3FTOHk',
    tabs: '_3xE3E1Hn',
    alignBottom: '_20c55o3s',
    indicatorActive: '_1zXbd0Xd',
    indicatorContent: '_3z8svFZx',
    tabButtonContent: '_3aW00OT0',
    ' _key': 'apic-theme/apic/base-widgets/tab-container'
};
export default css;
